<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'PassengerTransportation',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        // customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 100,
      }, {
        dataField: 'VehicleNumber',
        caption: 'Номер ТС',
      }, {
        caption: 'Передняя дверь',
        alignment: 'center',
        columns: [
          {
            dataField: 'FirstDoorIn',
            caption: 'Вход',
            alignment: 'left',
            width: 70,
          }, {
            dataField: 'FirstDoorOut',
            caption: 'Выход',
            alignment: 'left',
            width: 80,
          },
        ],
      }, {
        caption: 'Средняя дверь',
        alignment: 'center',
        columns: [
          {
            dataField: 'MiddleDoorIn',
            caption: 'Вход',
            alignment: 'left',
            width: 70,
          }, {
            dataField: 'MiddleDoorOut',
            caption: 'Выход',
            alignment: 'left',
            width: 80,
          },
        ],
      }, {
        caption: 'Задняя дверь',
        alignment: 'center',
        columns: [
          {
            dataField: 'LastDoorIn',
            caption: 'Вход',
            alignment: 'left',
            width: 70,
          }, {
            dataField: 'LastDoorOut',
            caption: 'Выход',
            alignment: 'left',
            width: 80,
          },
        ],
      }, {
        caption: 'Итого',
        alignment: 'center',
        columns: [
          {
            dataField: 'TotalIn',
            caption: 'Вход',
            alignment: 'left',
            width: 70,
          }, {
            dataField: 'TotalOut',
            caption: 'Выход',
            alignment: 'left',
            width: 80,
          },
        ],
      }],
      rowClick: null,
      reportSummary: [],
      index: 0,
    };
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
  },
  methods: {
    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },

  },
};
</script>
